// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8":"chart-vendor","919":"chart-loader"}[chunkId] + "." + {"8":"ac60e0ea60f901d7e901","919":"b735a1c738c0845bc39e"}[chunkId] + ".min.js";
};